export type IToggleScrollToTopButton = (win: JQuery<Window> | Window) => void;

export function _toggleScrollToTopButton(win: JQuery<Window> | Window): void {
  const $win = $(win);
  const $button = $('#scroll-to-top');
  const documentHeight = $(document).height() || 0;
  const documentHeight25Perct = Number(parseFloat((documentHeight / 4).toString()).toFixed(0));
  const windowDistanceToTop = $win.scrollTop() || 0;
  let action = 'hide';

  if (windowDistanceToTop > documentHeight25Perct) {
    action = 'show';
  }

  if (action === 'show') {
    $button.removeClass('hide').attr('aria-hidden', 'false');
  } else {
    $button.addClass('hide').attr('aria-hidden', 'true');
  }
}
